import type { GatsbyBrowser } from 'gatsby';
import type { Theme } from './src/types/theme';

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  try {
    // Close any lingering Bootstrap offcanvas/backdrops between route changes
    const openOffcanvas = document.querySelectorAll('.offcanvas.show');
    openOffcanvas.forEach((el) => el.classList.remove('show'));
    const body = document.body;
    body.classList.remove('offcanvas-backdrop', 'modal-open');
    const backdrops = document.querySelectorAll('.offcanvas-backdrop, .modal-backdrop');
    backdrops.forEach((el) => el.parentElement?.removeChild(el));

    // Handle hash navigation after route updates for smooth scrolling
    if (location && location.hash) {
      const id = location.hash.replace('#', '');
      const target = document.getElementById(id);
      if (target) {
        // Defer to ensure layout is stable
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
      }
    }

    // Re-init theme scripts if available
    const theme: Theme | undefined = typeof window !== 'undefined' ? window.theme : undefined;
    if (theme) {
      if (typeof theme.init === 'function') theme.init();
      if (typeof theme.swiperSlider === 'function') theme.swiperSlider();
      // Ensure animations, grid layout, and page progress are bound after navigation
      // Note: scrollCue is kept for backward compatibility with any remaining data-cue attributes
      setTimeout(() => {
        if (typeof theme.scrollCue === 'function') theme.scrollCue();
        if (typeof theme.isotope === 'function') theme.isotope();
        if (typeof theme.pageProgress === 'function') theme.pageProgress();
      }, 0);
    }
  } catch {}
};
